<script setup>
import AutocompleteFilter from '@/components/widgets/AutocompleteFilter.vue';
import { ref, inject, onMounted } from 'vue';
import { useFetchData } from '@/composables/use-fetchData';

const backendApi = inject('backendApi');

const emit = defineEmits(['update']);

const selected = ref(null);
const searchQuery = ref('');

const { result, loading, displayHttpError, loadData } = useFetchData(
    backendApi().state().index
);

const getStates = () => {
    loadData({
        pattern: searchQuery.value,
        active: true
    });
};

const cleanData = () => {};

onMounted(() => getStates());
</script>

<template>
    <AutocompleteFilter
        v-model="selected"
        v-model:search="searchQuery"
        item-title="name"
        item-value="id"
        :items="result"
        :label="$t('State')"
        :loading="loading"
        :show-retry-button="displayHttpError"
        @update="emit('update', selected)"
        @preparing-search="cleanData"
        @search="getStates"
        @retry="getStates"
        @update:focused="(state) => emit('update:focused', state)"
    >
        <template v-slot:default="{ props, item }">
            <v-list-item
                v-bind="props"
                :title="`${item.raw.name}`"
                :subtitle="`${item.raw.country?.name}`"
            >
            </v-list-item>
        </template>
    </AutocompleteFilter>
</template>
